import FormField from '@/shared/ui/FormField';
import { OPTIONS } from '../model/demoLead';
import ChoiceGroup from './ChoiceGroup';
import { Checkbox } from '@/shared/ui/checkbox';

/** Step 4: obiettivo, prossimo step, note e consenso. */
export default function ContactStep({ lead, errors, onText, onChoose }) {
  return (
    <>
      <FormField
        id="demo-objective"
        name="objective"
        label="Obiettivo principale della consulenza"
        required
        rows={4}
        value={lead.objective}
        error={errors.objective}
        onChange={(value) => onText('objective', value)}
        placeholder="Es. centralizzare tracking, costi e manutenzioni in un'unica vista per la sala operativa."
        hint="Risultato atteso"
      />
      <ChoiceGroup
        id="demo-preferredContact"
        label="Prossimo step preferito"
        options={OPTIONS.preferredContact}
        selected={lead.preferredContact}
        error={errors.preferredContact}
        onChoose={(value) => onChoose('preferredContact', value)}
        hint="Come vuoi procedere"
      />
      <FormField
        id="demo-notes"
        name="notes"
        label="Note utili per la demo"
        rows={5}
        value={lead.notes}
        onChange={(value) => onText('notes', value)}
        placeholder="Vincoli, integrazioni, sedi, stakeholder, tempistiche…"
        hint="Facoltativo"
      />
      <div>
        <Checkbox
          id="demo-consent"
          name="consent"
          aria-required
          checked={lead.consent}
          onCheckedChange={(checked) => onText('consent', checked)}
          aria-invalid={Boolean(errors.consent)}
          aria-describedby={errors.consent ? 'demo-consent-error' : undefined}
          className="rounded-lg border border-default bg-subtle px-4 py-3"
        >
          Autorizzo il contatto per organizzare la consulenza e la demo dedicata.
        </Checkbox>
        {errors.consent && (
          <p id="demo-consent-error" className="mt-1 text-caption text-danger">
            {errors.consent}
          </p>
        )}
      </div>
    </>
  );
}
